<template>
  <div class="row">
    <div class="col-md-12">
      <!-- <router-link class="btn btn-orange" title="Back to settings" :to="{ path: '/settings'}"><i class="ti-arrow-left"></i> Back</router-link> -->
      <element-form :route="route" @on-submit="onUserSubmit"></element-form>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Select, Option} from 'element-ui'
  import ElementForm from './GroupOptionsForm.vue'
  Vue.use(Select)
  export default {
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      ElementForm
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        elementModel: {},
        modelValidations: {
          required: {
            required: true
          }
        }
      }
    },
    methods: {
      onUserSubmit (model, isValid) {
        this.elementModel = model
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/GroupOptions/GroupOptionsAdd.vue